"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _locale = _interopRequireDefault(require("../accordion/locale"));
var _locale2 = _interopRequireDefault(require("../breadcrumbs/locale"));
var _locale3 = _interopRequireDefault(require("../datepicker/locale"));
var _locale4 = _interopRequireDefault(require("../data-table/locale"));
var _locale5 = _interopRequireDefault(require("../button-group/locale"));
var _locale6 = _interopRequireDefault(require("../file-uploader/locale"));
var _locale7 = _interopRequireDefault(require("../menu/locale"));
var _locale8 = _interopRequireDefault(require("../modal/locale"));
var _locale9 = _interopRequireDefault(require("../drawer/locale"));
var _locale10 = _interopRequireDefault(require("../pagination/locale"));
var _locale11 = _interopRequireDefault(require("../select/locale"));
var _locale12 = _interopRequireDefault(require("../toast/locale"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const en_US = {
  accordion: _locale.default,
  breadcrumbs: _locale2.default,
  datepicker: _locale3.default,
  datatable: _locale4.default,
  buttongroup: _locale5.default,
  fileuploader: _locale6.default,
  menu: _locale7.default,
  modal: _locale8.default,
  drawer: _locale9.default,
  pagination: _locale10.default,
  select: _locale11.default,
  toast: _locale12.default
};
var _default = exports.default = en_US;